export const globalConfig = {
  appName: 'awesome-back-office-laksjd',
}
